module.exports = __webpack_public_path__ + "static/img/single-window_256.7d32bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/single-window_256.png
// module id = saX2
// module chunks = 0